import { render, staticRenderFns } from "./IncomeAndExpenditure.vue?vue&type=template&id=13e91978&"
import script from "./IncomeAndExpenditure.vue?vue&type=script&lang=js&"
export * from "./IncomeAndExpenditure.vue?vue&type=script&lang=js&"
import style0 from "./IncomeAndExpenditure.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports